import removeBlankProperties from 'utils/removeBlankProperties';
import get from 'lodash/get';
import map from 'lodash/map';

function makeSentinelTeamIdentity(sentinelTeam = {}) {
  /* istanbul ignore next -- @preserve */
  const {
    id,
    name,
    owner = {},
    teamType,
    teamKey,
    platformAccounts = [],
    oemSegment = {},
  } = sentinelTeam || {};

  // Default OEM segment values for Pendo integration.
  // Pendo doesn't support querying for undefined values, so we always
  // provide oemSegmentKey and oemSegmentName even when no OEM segment exists
  // for the team or when OEM segment fields are blank.
  // Defaults: key = 'sentinel', name = 'Sentinel App'
  const oemSegmentKey = get(oemSegment, 'key') || 'sentinel';
  const oemSegmentName = get(oemSegment, 'name') || 'Sentinel App';

  return removeBlankProperties({
    id,
    name,
    owner: get(owner, 'email'),
    teamType,
    teamKey,
    platformAccounts: map(platformAccounts, (account) => account.sourceId),
    oemSegmentId: get(oemSegment, 'id'),
    oemSegmentName,
    oemSegmentKey,
  });
}

export default makeSentinelTeamIdentity;
